import React from 'react'

import * as d3 from 'd3'
import './Sun.css'
import './SunD3.js'
import './SunD3.css'

const getDayOfYear = date => (Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()) - Date.UTC(date.getFullYear(), 0, 0)) / 24 / 60 / 60 / 1000
const URL = 'balesetek_napok.json'

function Sun ({options, size}) {
  const data = options.data;
 // if (data.length>0 ||data === false) {
      if (data === false) data = [];
      let sunData = {};
      for (const day of data) {
       if ("date" in day) {
          if (!sunData[day.date]) {
            sunData[day.date] = {date : day.date, count: 1}
          } else {
            sunData[day.date].count++
          }
        }
        else {
          if (!sunData[day.properties.date]) {
            sunData[day.properties.date] = {date : day.properties.date, count: 1}
          } else {
            sunData[day.properties.date].count++
          }
        }
      }
      d3.select("#main-sun").sun()
          .circleType(options.type)
          .size(size)
          .radius(size/4)
          .sundata(Object.values(sunData))
    //}
  return ('')
}

export default Sun
